import htmlToPdfmake from "html-to-pdfmake"
import {
    AccountSettings,
    ProjectSettings,
    LangType,
} from "client/store"
import * as Const from "client/components/pdfmake/template/const"

const AppendixBPage = (
    accountSettings: AccountSettings,
    projectSettings: ProjectSettings,
    lang: LangType,
) => {
    const { defaultAssumption } = accountSettings.sil
    const { assumption } = projectSettings.sil
    const assumptionConverted = htmlToPdfmake(assumption || defaultAssumption)

    return [
        {
            pageBreak: "before",
            style: Const.HEADER,
            text: `4.  ${lang.appendix}  B - ${lang.calculationAssumptions}`,
            ...Const.TOC_HEADER_BASE,
        },
        {
            style: Const.PARAGRAPH,
            stack: assumptionConverted,
        },
    ] as any[]
}
export default AppendixBPage
